import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isU8a, u8aConcatStrict } from '@polkadot/util';
import { AbstractArray } from "../abstract/AbstractArray.js";
import { decodeU8aVec, typeToConstructor } from "../utils/index.js";
import { decodeVec } from "./Vec.js";

function noopSetDefinition(d) {
  return d;
}
/**
 * @name VecFixed
 * @description
 * This manages codec arrays of a fixed length
 */


var _Type = /*#__PURE__*/new WeakMap();

export var VecFixed = /*#__PURE__*/function (_AbstractArray) {
  _inherits(VecFixed, _AbstractArray);

  var _super = _createSuper(VecFixed);

  function VecFixed(registry, Type, length) {
    var _this;

    var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
        definition = _ref.definition,
        _ref$setDefinition = _ref.setDefinition,
        setDefinition = _ref$setDefinition === void 0 ? noopSetDefinition : _ref$setDefinition;

    _classCallCheck(this, VecFixed);

    _this = _super.call(this, registry, length);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _Type, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _Type, definition || setDefinition(typeToConstructor(registry, Type)));

    var _ref2 = isU8a(value) ? decodeU8aVec(registry, _assertThisInitialized(_this), value, 0, _classPrivateFieldGet(_assertThisInitialized(_this), _Type)) : decodeVec(registry, _assertThisInitialized(_this), value, 0, _classPrivateFieldGet(_assertThisInitialized(_this), _Type)),
        _ref3 = _slicedToArray(_ref2, 2),
        decodedLengthNoOffset = _ref3[1];

    _this.initialU8aLength = decodedLengthNoOffset;
    return _this;
  }

  _createClass(VecFixed, [{
    key: "Type",
    get:
    /**
     * @description The type for the items
     */
    function get() {
      return new (_classPrivateFieldGet(this, _Type))(this.registry).toRawType();
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */

  }, {
    key: "encodedLength",
    get: function get() {
      var total = 0;

      for (var i = 0; i < this.length; i++) {
        total += this[i].encodedLength;
      }

      return total;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      return {
        inner: this.inspectInner()
      };
    }
  }, {
    key: "toU8a",
    value: function toU8a() {
      // we override, we don't add the length prefix for ourselves, and at the same time we
      // ignore isBare on entries, since they should be properly encoded at all times
      var encoded = this.toU8aInner();
      return encoded.length ? u8aConcatStrict(encoded) : new Uint8Array([]);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "[".concat(this.Type, ";").concat(this.length, "]");
    }
  }], [{
    key: "with",
    value: function _with(Type, length) {
      var definition; // eslint-disable-next-line no-return-assign

      var setDefinition = function setDefinition(d) {
        return definition = d;
      };

      return /*#__PURE__*/function (_VecFixed) {
        _inherits(_class, _VecFixed);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, Type, length, value, {
            definition: definition,
            setDefinition: setDefinition
          });
        }

        return _createClass(_class);
      }(VecFixed);
    }
  }]);

  return VecFixed;
}(AbstractArray);